














import { Component } from 'vue-property-decorator';
import UnitSelector from '@/views/product/common/UnitSelector.vue';
import ProductImage from '@/views/product/common/ProductImage.vue';
import ProductTitle from '@/views/product/common/ProductTitle.vue';
import OrderProduct from '@/views/product/widgets/OrderProduct.vue';
import { AbstractGroupWidget } from '@/views/product/widgets/AbstractGroupWidget';
import { ShoppingCartItemDto } from '@/api';

@Component({
  components: {
    ProductImage,
    ProductTitle,
    UnitSelector,
    OrderProduct,
  },
})
export default class OrderGroup extends AbstractGroupWidget {

  public bindKey(item: ShoppingCartItemDto) {
    return `${item.sku}_${item.unitAbbreviation}`;
  }
}
